export const MILESTONES_GET_STATUSES_LIST = 'MILESTONES_GET_STATUSES_LIST';
export const MILESTONES_GET_STATUSES_LIST_SUCCESS = 'MILESTONES_GET_STATUSES_LIST_SUCCESS';
export const MILESTONES_GET_STATUSES_LIST_ERROR = 'MILESTONES_GET_STATUSES_LIST_ERROR';